<template>
  <div id="app">
    <MyTabBar></MyTabBar>
  </div>
</template>

<script>
import MyTabBar from "./components/MyTabBar";
export default {
  name: "App",
  components: {
    MyTabBar,
  },
};
</script>

<style>
#app {
  max-width: 375px;
  height: 887px;
  font-size: 16px;
  padding: 29px 24px;
  background-color: #13118f;
  box-sizing: border-box;
}
@media screen and (min-width: 1125PX) {
  #app {
    width: 1125PX;
    height: 2660PX;
  font-size: 16px;
  padding: 88PX 72PX;
  margin: 0 auto;
  }
}
</style>
